<div class="option"
     [class.hidden]="isHidden"
     [class.selected-item]="isSelected"
     [class.disabled]="disabled"
     [attr.aria-disabled]="disabled || null"
     (click)="click.emit()"
     #content>
  @if (optionIcon) {
<img [src]="optionIcon"/>
}
  <ng-content></ng-content>
</div>
